import { useEffect } from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/sections/Hero";
import TrustBar from "@/components/sections/TrustBar";
import Services from "@/components/sections/Services";
import About from "@/components/sections/About";
import WhyChoose from "@/components/sections/WhyChoose";
import Process from "@/components/sections/Process";
import Portfolio from "@/components/sections/Portfolio";
import Industries from "@/components/sections/Industries";
import Metrics from "@/components/sections/Metrics";
import Testimonials from "@/components/sections/Testimonials";
import Pricing from "@/components/sections/Pricing";
import FAQ from "@/components/sections/FAQ";
import ContactCTA from "@/components/sections/ContactCTA";

export default function HomePage() {
  useEffect(() => {
    document.title = "APEX Innovation Solutions | Web Design, SEO & AEO Agency for Business Growth";
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="home-page" className="relative overflow-x-hidden">
      <Navbar />
      <Hero />
      <TrustBar />
      <Services />
      <About />
      <WhyChoose />
      <Process />
      <Portfolio />
      <Industries />
      <Metrics />
      <Testimonials />
      <Pricing />
      <FAQ />
      <ContactCTA />
      <Footer />
    </main>
  );
}
